import { createSelector } from 'reselect';
const getLinescore = (state) => state.gumbo?.liveData?.linescore || {};
const getStrikes = (state) => getLinescore(state)?.strikes;
const getOuts = (state) => getLinescore(state)?.outs;
const getBalls = (state) => getLinescore(state)?.balls;
const getOffense = (state) => getLinescore(state)?.offense;
const getFirst = (state) => getOffense(state)?.first;
const getSecond = (state) => getOffense(state)?.second;
const getThird = (state) => getOffense(state)?.third;

export const getGameDetails = createSelector(
    [getStrikes, getBalls, getOuts, getFirst, getSecond, getThird],
    (strikes, balls, outs, first, second, third) => {
        return {
            balls,
            strikes,
            outs,
            first,
            second,
            third
        };
    }
);
